
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Patient } from "../../../domain/patient";

@Component({
})
export default class SpecifiedPatientViewMixin extends Mixins() {
  @Prop()
  patientNo: string;

  @Prop({ default: "" })
  presetFilterKey: string;

  data(): any {
    return {
      patient: null as Patient,
      isPatientNoInvalid: false,
    };
  }
  patient: Patient;
  isPatientNoInvalid: boolean;

  get shouldSelectPatient(): boolean {
    return (!this.patientNo || (this.patientNo === "") || (this.isPatientNoInvalid))
        && !this.patient;
  }

  created(): void {
    this.loadPatient();
  }

  async loadPatient(): Promise<void> {
    if (this.patientNo && this.patientNo !== "") {
      try {
        const repository = DomainRegistry.patient.getPatientRepository();
        this.patient = await repository.getEntity(this.patientNo);
      } catch (e) {
        this.$error(
          "患者番号不正",
          "入力された患者番号に該当する患者が見つかりませんでした。",
          e,
        );
        this.isPatientNoInvalid = true;
      }
    }
  }
}
